import React from "react";
import "./index.scss";
import Modal from "react-bootstrap/Modal";

const CustomModal = ({
  show,
  handleClose,
  title,
  children,
  className,
  headerClass,
  size
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      className={className ? className : ""}
      size={size}
    >
      <Modal.Header className={headerClass ? headerClass : ""} closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default CustomModal;
